import store from '../store'
import notification from '@utils/notification'

const interceptors = {
  async request(config) {
    if (store.getState().auth.isAuthenticated) {
      const token = await store.getActions().auth.getToken()
      // Send the token back up with every request
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
    }

    loadingCount.increase(config)
    return config
  },

  response(res) {
    // Decrement request count to hide loader
    loadingCount.decrease(res.config)

    return Promise.resolve(res)
  },

  async error(error) {
    /**
     * If we receive an Unauthorized error then we must send them to login.
     */
    if (error.response && error.response.status === 401) {
      return store.getActions().auth.loginWithRedirect({ path: '/' })
    }

    // Decrement request count to hide loader
    loadingCount.decrease(error.config)

    /** Raise error when we get one from backend */
    if (error.response) {
      notification({
        type: 'error',
        message:
          error.response.data?.message ??
          error.response?.message ??
          error.response?.data ??
          error.response?.status
      })

      if (error.response.data?.errors) {
        error.response.data.errors.forEach(err => {
          notification({
            type: 'error',
            message: err.message
          })
        })
      }
    }

    return Promise.reject(error)
  }
}

const loadingCount = {
  increase({ url = '' } = {}) {
    store.getActions().ui.increaseApiLoading()
  },

  decrease({ url = '' } = {}) {
    store.getActions().ui.decreaseApiLoading()
  }
}

export default interceptors
